import { Box, styled } from '@mui/material';

export const ColumnHeader = styled(Box)`
  color: #fcd119;
  font-size: 19px;
  font-weight: 300;
`;
